
import Text from '../text/index.jsx'
import Selector from '../selector/index.jsx'
import SetColor from '../setColor/index.jsx'
import SlideBar1 from '../slideBar1/index.jsx'
import { useState } from 'react'
import './side.less'
import React from 'react'
const te = ['left', 'center', 'right']
console.log(React, te)
export default function BasicsTextSide(props) {
  const [ifon, setIfon] = useState({
    fontSize: +props.ifon.font_size,
    fontWeight: props.ifon.font_style,
    textAlign: props.ifon.text_alignment
  })

  return (<div className='BasicsTextSide'>

    <div className='BasicsTextSide_no1'>
      <h3 className='title'>基础组件：文本</h3>
      <div className='tips'>支持腾讯广告全广告位</div>
    </div>
    <div className='BasicsTextSide_no2'>
      <h3 className='no2_title'>推广文案</h3>
      <div className='no2_main'>
        <Text text={props.ifon.text} setText={(value) => {
          props.mySetIfon && props.mySetIfon({
            ...props.ifon,
            text: value
          })
        }}></Text>
      </div>
    </div>

    <div className='BasicsTextSide_no3'>
      <h3 className='no3_title'>字符与段落</h3>
      <div className='no3_main'>
        <div className='main_item'>
          <span className='item_title'>
            字符样式
          </span>

          <div className='item_box'>
            <div className='box_no1'>
              <div className='no1_item'>
                <Selector options={[{ id: 14, text: '14' }, { id: 15, text: '15' }, { id: 16, text: '16' }, { id: 18, text: '18' }, { id: 20, text: '20' }, { id: 24, text: '24' }, { id: 36, text: '36' }]} activeId={ifon.fontSize} change={(item) => {
                  setIfon({
                    ...ifon,
                    activeId: item.id
                  })
                  props.mySetIfon && props.mySetIfon({
                    ...props.ifon,
                    font_size: item.id
                  })
                }}></Selector>
              </div>
              <div className='no1_item'>
                <SetColor color={props.ifon.font_color} setColor={(colorObj) => {
                  props.mySetIfon && props.mySetIfon({
                    ...props.ifon,
                    font_color: colorObj.hex
                  })
                }}></SetColor>
              </div>
            </div>
            <div className='no1_button'>
              <button className={`button ${ifon.fontWeight === 0 ? 'active' : ''}`} onClick={() => {
                setIfon({
                  ...ifon,
                  fontWeight: 0
                })
                props.mySetIfon && props.mySetIfon({
                  ...props.ifon,
                  font_style: 0
                })
              }}>常规</button>
              <button className={`button ${ifon.fontWeight === 1 ? 'active' : ''}`} onClick={() => {
                setIfon({
                  ...ifon,
                  fontWeight: 1
                })
                props.mySetIfon && props.mySetIfon({
                  ...props.ifon,
                  font_style: 1
                })
              }}>加粗</button>
            </div>
          </div>
        </div>

        <div className='main_item'>
          <span className='item_title'>对齐方式</span>
          <div className='item_box1'>
            <button className={`button ${ifon.textAlign === 0 ? 'active' : ''}`} onClick={() => {
              setIfon({
                ...ifon,
                textAlign: 0
              })
              props.mySetIfon && props.mySetIfon({
                ...props.ifon,
                text_alignment: 0
              })
            }}>
              <svg class='adui-button-leftIcon adui-icon-base' width='18' height='18' viewBox='0 0 18 18' fill='var(--gray-700)' data-interactive='false' data-icon='format-align-left'><path d='M3.50342 4H9.49658C9.7671 4 10 4.22595 10 4.50468V5.49532C10 5.78596 9.77461 6 9.49658 6H3.50342C3.2329 6 3 5.77405 3 5.49532V4.50468C3 4.21404 3.22539 4 3.50342 4ZM3.50035 8H14.4997C14.771 8 15 8.22596 15 8.50468V9.49532C15 9.78596 14.776 10 14.4997 10H3.50035C3.229 10 3 9.77404 3 9.49532V8.50468C3 8.21404 3.22401 8 3.50035 8ZM3.50035 12H14.4997C14.771 12 15 12.226 15 12.5047V13.4953C15 13.786 14.776 14 14.4997 14H3.50035C3.229 14 3 13.774 3 13.4953V12.5047C3 12.214 3.22401 12 3.50035 12Z' fill-rule='evenodd'></path></svg></button>
            <button onClick={() => {
              setIfon({
                ...ifon,
                textAlign: 1
              })
              props.mySetIfon && props.mySetIfon({
                ...props.ifon,
                text_alignment: 1
              })
            }} className={`button ${ifon.textAlign === 1 ? 'active' : ''}`} ><svg class='adui-button-leftIcon adui-icon-base' width='18' height='18' viewBox='0 0 18 18' fill='var(--gray-700)' data-interactive='false' data-icon='format-align-center'><path d='M6.00342 4H11.9966C12.2671 4 12.5 4.22595 12.5 4.50468V5.49532C12.5 5.78596 12.2746 6 11.9966 6H6.00342C5.7329 6 5.5 5.77405 5.5 5.49532V4.50468C5.5 4.21404 5.72539 4 6.00342 4ZM6.00342 12H11.9966C12.2671 12 12.5 12.226 12.5 12.5047V13.4953C12.5 13.786 12.2746 14 11.9966 14H6.00342C5.7329 14 5.5 13.774 5.5 13.4953V12.5047C5.5 12.214 5.72539 12 6.00342 12ZM3.50035 8H14.4997C14.771 8 15 8.22596 15 8.50468V9.49532C15 9.78596 14.776 10 14.4997 10H3.50035C3.229 10 3 9.77404 3 9.49532V8.50468C3 8.21404 3.22401 8 3.50035 8Z' fill-rule='evenodd'></path></svg></button>
            <button onClick={() => {
              setIfon({
                ...ifon,
                textAlign: 2
              })
              props.mySetIfon && props.mySetIfon({
                ...props.ifon,
                text_alignment: 2
              })
            }} className={`button ${ifon.textAlign === 2 ? 'active' : ''}`}><svg class='adui-button-leftIcon adui-icon-base' width='18' height='18' viewBox='0 0 18 18' fill='var(--gray-700)' data-interactive='false' data-icon='format-align-right'><path d='M8.50342 4H14.4966C14.7671 4 15 4.22595 15 4.50468V5.49532C15 5.78596 14.7746 6 14.4966 6H8.50342C8.2329 6 8 5.77405 8 5.49532V4.50468C8 4.21404 8.22539 4 8.50342 4ZM3.50035 8H14.4997C14.771 8 15 8.22596 15 8.50468V9.49532C15 9.78596 14.776 10 14.4997 10H3.50035C3.229 10 3 9.77404 3 9.49532V8.50468C3 8.21404 3.22401 8 3.50035 8ZM3.50035 12H14.4997C14.771 12 15 12.226 15 12.5047V13.4953C15 13.786 14.776 14 14.4997 14H3.50035C3.229 14 3 13.774 3 13.4953V12.5047C3 12.214 3.22401 12 3.50035 12Z' fill-rule='evenodd'></path></svg></button>
          </div>
        </div>

      </div>
    </div>

    <div className='BasicsTextSide_no4'>
      <h3 className='no4_title'>边距</h3>
      <div className='no4_main'>
        <div className='main_item'>
          <SlideBar1 title={'上边距'} value={props.ifon.padding_top} speed={(value) => {
            props.mySetIfon && props.mySetIfon({
              ...props.ifon,
              padding_top: value
            })
          }}></SlideBar1>
        </div>
        <div className='main_item'>
          <SlideBar1 title={'下边距'} value={props.ifon.padding_bottom} speed={(value) => {
            props.mySetIfon && props.mySetIfon({
              ...props.ifon,
              padding_bottom: value
            })
          }}></SlideBar1>
        </div>
      </div>
    </div>
  </div>)
}
